export default __webpack_public_path__ + "static/media/Stones01.9ef2ef42.png";